export default {"src":"https://fishbrain.com/_next/static/media/ic_weather_night_296.8b97ef2a.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};